import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { CreateRenameFolderConfig } from './create-rename-folder-config';

@Injectable({
  providedIn: 'root'
})
export class CreateRenameFolderModalService extends BaseModalService<CreateRenameFolderConfig> {}
